webpackJsonp([114276838955818,60335399758886],{

/***/ 115:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(267);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(115);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 402:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _gatsbyLink = __webpack_require__(26);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    "footer",
	    { id: "footer" },
	    _react2.default.createElement(
	      "ul",
	      { className: "icons" },
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "a",
	          {
	            href: "https://twitter.com/alexisgiard",
	            className: "icon alt fa-twitter",
	            target: "_blank"
	          },
	          _react2.default.createElement(
	            "span",
	            { className: "label" },
	            "Twitter"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "a",
	          {
	            href: "https://ch.linkedin.com/in/alexis-giard-52846718",
	            className: "icon alt fa-linkedin",
	            target: "_blank"
	          },
	          _react2.default.createElement(
	            "span",
	            { className: "label" },
	            "LinkedIn"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "a",
	          {
	            href: "https://github.com/alexisgea",
	            className: "icon alt fa-github",
	            target: "_blank"
	          },
	          _react2.default.createElement(
	            "span",
	            { className: "label" },
	            "GitHub"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        _react2.default.createElement(
	          "a",
	          {
	            href: "mailto:alexis.giard@gmail.com",
	            className: "icon alt fa-envelope"
	          },
	          _react2.default.createElement(
	            "span",
	            { className: "label" },
	            "Email"
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports["default"];

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _gatsbyLink = __webpack_require__(26);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(_ref) {
	  var onToggleMenu = _ref.onToggleMenu;
	
	  return _react2.default.createElement(
	    "header",
	    { id: "header" },
	    _react2.default.createElement(
	      "h1",
	      { id: "logo" },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: "/" },
	        "Alexis - Game Developer"
	      )
	    ),
	    _react2.default.createElement(
	      "nav",
	      { id: "nav" },
	      _react2.default.createElement(
	        "ul",
	        null,
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { onClick: onToggleMenu, to: "/projects" },
	            "Projects"
	          )
	        ),
	        _react2.default.createElement(
	          "li",
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { onClick: onToggleMenu, to: "/blog" },
	            "Blog"
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports["default"];

/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _gatsbyLink = __webpack_require__(26);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MobileMenu = function MobileMenu(_ref) {
	  var onToggleMenu = _ref.onToggleMenu;
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      "div",
	      { id: "titleBar" },
	      _react2.default.createElement("a", { href: "#", onClick: onToggleMenu, className: "toggle" }),
	      _react2.default.createElement(
	        "span",
	        { className: "title" },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/" },
	          "Alexis - Game Developer"
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { id: "navPanel" },
	      _react2.default.createElement(
	        "nav",
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            className: "link depth-0",
	            onClick: onToggleMenu,
	            to: "/projects"
	          },
	          "Projects"
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: "link depth-0", onClick: onToggleMenu, to: "/blog" },
	          "Blog"
	        )
	      )
	    )
	  );
	};
	
	exports.default = MobileMenu;
	module.exports = exports["default"];

/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Footer = __webpack_require__(264);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Header = __webpack_require__(265);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(402);
	
	var _MobileMenu = __webpack_require__(266);
	
	var _MobileMenu2 = _interopRequireDefault(_MobileMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Template = function (_Component) {
	  _inherits(Template, _Component);
	
	  function Template() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Template);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      isNavPanelVisible: false
	    }, _this.handleToggleMenu = function () {
	      _this.setState({
	        isNavPanelVisible: !_this.state.isNavPanelVisible
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Template.prototype.render = function render() {
	    var _props = this.props,
	        location = _props.location,
	        children = _props.children;
	
	
	    var rootPath = "/";
	    if (false) {
	      rootPath = __PATH_PREFIX__ + "/";
	    }
	
	    if (location.pathname === rootPath) {}
	
	    return _react2.default.createElement(
	      "div",
	      {
	        className: "body " + (this.state.isNavPanelVisible ? "navPanel-visible" : "")
	      },
	      _react2.default.createElement(_MobileMenu2.default, { onToggleMenu: this.handleToggleMenu }),
	      _react2.default.createElement(
	        "div",
	        { id: "page-wrapper" },
	        _react2.default.createElement(_Header2.default, { onToggleMenu: this.handleToggleMenu }),
	        children(),
	        _react2.default.createElement(_Footer2.default, null)
	      )
	    );
	  };
	
	  return Template;
	}(_react.Component);
	
	exports.default = Template;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-1fa602e57c6b044f482f.js